import { createSelector } from '@reduxjs/toolkit';

const nbs = (state) => state?.nextBillSummary || {};

export const nbsState = createSelector(nbs, (state) => state);
export const getNBSData = createSelector(nbs, (state) => state.nbsVo);
export const getNBSError = createSelector(nbs, (state) => state?.nbsError);
export const getFeatureFlag = createSelector(nbs, (state) => state?.dbrFlag);
